export default {
  methods: {
    getPaymentMinMaxValue (min, max) {
      return { 'minValue': min, 'maxValue': max }
    },
    getMessageByError (code) {
      switch (code) {
        case 3:
          return 'api_error_3'
        case 5:
          return 'api_error_5'
        case 101:
          return 'api_error_101'
        case 107:
          return 'api_error_107'
        case 204:
          return 'api_error_204'
        case 205:
          return 'api_error_205'
        case 206:
          return 'api_error_206'
        case 207:
          return 'api_error_207'
        case 208:
          return 'api_error_208'
        case 209:
          return 'api_error_209'
        case 210:
          return 'api_error_210'
      }
    },
    getMessageByErrorParams (code, min, max) {
      switch (code) {
        case 205:
        case 206:
        case 207:
        case 208:
          return this.getPaymentMinMaxValue(min, max)
        case 209:
          return { 'maxValue': max }
      }
      return null
    }
  }
}
